import Allies from './Allies'

export default Allies
